import ContactPage from './ContactPageShell';

export default ContactPage;
